import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from './components/pages/Home.vue'
import NotFound from './components/pages/NotFound.vue'
import Deleted from './components/pages/Deleted.vue'
import Closed from './components/pages/Closed.vue'
import Respond from './components/pages/Respond.vue'

import axios from 'axios'

Vue.use(VueRouter)

export default new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'NotFound',
      component: NotFound
    },
    {
      path: '/',
      name: 'Deleted',
      component: Deleted
    },
    {
      path: '/',
      name: 'Closed',
      component: Closed
    },
    {
      path: '/quoterequest/:id',
      name: 'Home',
      component: Home,
      beforeEnter: (to, from, next) => {
        const {params} = to
        const AuthStr = `Bearer ${params.id}`
        axios.get(`${window.APP_CONFIG.apiServiceUrl}quoterequest/portal/verify`, {headers: {Authorization: AuthStr}})
          .then(response => {
            next() // Proceed to the component and display it
          })
          .catch((error) => {
            console.error('error', error, this)
            next({name: 'NotFound'})
          })
      }
    },
    {
      path: '/respond/:r/:t',
      name: 'Respond',
      component: Respond,
      beforeEnter: (to, from, next) => {
        const {params} = to
        const AuthStr = `Bearer ${params.t}`
        axios.post(`${window.APP_CONFIG.apiServiceUrl}quoterequest/portal/respond/${params.r}`, null, {headers: {Authorization: AuthStr}})
          .then(response => {
            switch (params.r) {
              case 'no': // This is legacy from older links , won't be available in new emails.
              case 'later': // This is legacy from older links , won't be available in new emails.
                return next()
              case 'yes': // This is legacy from older links , won't be available in new emails.
              case 'opened':
                return next({path: `/quoterequest/${params.t}`})
              default:
                return next({path: `/`})
            }
          })
          .catch((error) => {
            const msg = error.response.data.message || error.response.data.Message
            switch (msg) {
              case 'This request has been deleted':
                return next({name: 'Deleted'})
              case 'This request is now closed':
              case 'Estimate is Accepted, quoting is closed':
              case 'Quote has already been accepted':
                return next({name: 'Closed'})
              default:
                return next({name: 'NotFound'})
            }
          })
      }
    }
  ]
})
